import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setTitle } from '../actions/topbar.actions';
import { customers as page } from './';

class Customers extends Component {
  componentWillMount() {
    this.props.setTitle(page.title);
  }
  render() {
    return (
      <div>{page.title}</div>
    )
  }
}

function mapStateToProps(state) {
  return {}
}
export default connect(mapStateToProps, {setTitle})(Customers)



// WEBPACK FOOTER //
// ./src/pages/Customers.js